// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-view__container {
    margin-left: 456px;
}

.baloa-play-view__skeleton-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin: 24px 64px 0 64px;
}

.baloa-play-view__skeleton-container__element {
    border-radius: 8px;
    background: var(--white-color);
    box-shadow: 0px 3.288px 3.288px 0px rgba(170, 193, 182, 0.32);
}

.baloa-play-view__skeleton-container__element__image-line {
    display: flex;
    align-items: center;
    padding: 10px;
    gap: 8px;
}

.baloa-play-view__skeleton-container__element__text-lines {
    padding: 5px 10px 10px 10px;
}

.baloa-play-view__skeleton-container-clips {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px 27px;
    margin: 30px 72px 10px 72px;
}

.baloa-play-view__skeleton-container__element-clips {
    border-radius: 8px;
    background: var(--white-color);
    padding: 12px;
    box-shadow: 0px 3.288px 3.288px 0px rgba(170, 193, 182, 0.32);
}

.baloa-play-view__skeleton-container__element__text-lines-clips {
    margin-top: 12px;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.baloa-play-view__empty-search-results {
    margin: 96px 64px 0 64px;
    text-align: center;
}

.baloa-play-view__empty-search-results .baloa-subtitle-2 {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    margin-top: 31px;
}

.baloa-play-view__empty-my-clips {
    margin: 140px 72px 0 72px;
    text-align: center;
}

.baloa-play-view__empty-my-clips .baloa-subtitle-2 {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    margin-top: 31px;
    max-width: 362px;
    margin-left: auto;
    margin-right: auto;
}

.baloa-play-view__section-header {
    padding: 24px 29px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: var(--white-color);
    border-bottom: 1psx solid var(--new-gray-background-color);
}

.baloa-play-view__section-header .baloa-headline-2 {
    color: var(--primary-very-dark-color);
}

.baloa-play-view__section-header .icon-arrow-left {
    font-size: 28px;
    margin-right: 10px;
    cursor: pointer;
}

.baloa-play-view__matc-acces-denied {
    text-align: center;
    margin-top: 97px;
    width: 490px;
    margin-left: auto;
    margin-right: auto;
}

.baloa-play-view__matc-acces-denied .baloa-normal-medium {
    color: var(--primary-very-dark-color);
    margin-top: 24px;
}

.baloa-play-view__matc-acces-denied .baloa-names {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    margin-top: 12px;
}

.baloa-play-view__empty-matches {
    margin-top: 44px;
    text-align: center;
    width: 364px;
    margin-left: auto;
    margin-right: auto;
}

.baloa-play-view__empty-matches .baloa-subtitle-2 {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
    margin-top: 31px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    
    .baloa-play-view__container {
        margin-left: 0;
    }

    .baloa-play-view__skeleton-container {
        grid-template-columns: 1fr;
        grid-gap: 8px;
        margin: 12px 9px;
    }

    .baloa-play-view__skeleton-container__element {
        display: flex;
        align-items: flex-start;
        padding: 8px;
        gap: 8px;
    }

    .baloa-play-view__skeleton-container__element__text-lines {
        width: calc(100% - 128px);
        padding: 0;
    }

    .baloa-play-view__skeleton-container-clips {
        grid-template-columns: 1fr;
        grid-gap: 10px;
        margin: 10px;
    }

    .baloa-play-view__skeleton-container__element__text-lines-clips {
        flex-wrap: nowrap;
        align-items: center;
    }

    .baloa-play-view__section-header {
        padding: 8px 12px 12px 12px;
    }

    .baloa-play-view__section-header .baloa-headline-2  {
        font-size: 18px;
    }

    .baloa-play-view__section-header .hubicon-clear_option {
        font-size: 24px;
        color: var(--primary-very-dark-color);
        margin-left: auto;
    }

    .baloa-play-view__matc-acces-denied {
        margin-top: 80px;
        width: 294px;
    }
    .baloa-play-view__empty-matches {
        margin-top: 130px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/views/BaloaPlayView.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,0DAA0D;AAC9D;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,0BAA0B;QAC1B,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,qCAAqC;QACrC,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".baloa-play-view__container {\n    margin-left: 456px;\n}\n\n.baloa-play-view__skeleton-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 20px;\n    margin: 24px 64px 0 64px;\n}\n\n.baloa-play-view__skeleton-container__element {\n    border-radius: 8px;\n    background: var(--white-color);\n    box-shadow: 0px 3.288px 3.288px 0px rgba(170, 193, 182, 0.32);\n}\n\n.baloa-play-view__skeleton-container__element__image-line {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    gap: 8px;\n}\n\n.baloa-play-view__skeleton-container__element__text-lines {\n    padding: 5px 10px 10px 10px;\n}\n\n.baloa-play-view__skeleton-container-clips {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 10px 27px;\n    margin: 30px 72px 10px 72px;\n}\n\n.baloa-play-view__skeleton-container__element-clips {\n    border-radius: 8px;\n    background: var(--white-color);\n    padding: 12px;\n    box-shadow: 0px 3.288px 3.288px 0px rgba(170, 193, 182, 0.32);\n}\n\n.baloa-play-view__skeleton-container__element__text-lines-clips {\n    margin-top: 12px;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.baloa-play-view__empty-search-results {\n    margin: 96px 64px 0 64px;\n    text-align: center;\n}\n\n.baloa-play-view__empty-search-results .baloa-subtitle-2 {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    margin-top: 31px;\n}\n\n.baloa-play-view__empty-my-clips {\n    margin: 140px 72px 0 72px;\n    text-align: center;\n}\n\n.baloa-play-view__empty-my-clips .baloa-subtitle-2 {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    margin-top: 31px;\n    max-width: 362px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.baloa-play-view__section-header {\n    padding: 24px 29px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    background: var(--white-color);\n    border-bottom: 1psx solid var(--new-gray-background-color);\n}\n\n.baloa-play-view__section-header .baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-view__section-header .icon-arrow-left {\n    font-size: 28px;\n    margin-right: 10px;\n    cursor: pointer;\n}\n\n.baloa-play-view__matc-acces-denied {\n    text-align: center;\n    margin-top: 97px;\n    width: 490px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.baloa-play-view__matc-acces-denied .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    margin-top: 24px;\n}\n\n.baloa-play-view__matc-acces-denied .baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    margin-top: 12px;\n}\n\n.baloa-play-view__empty-matches {\n    margin-top: 44px;\n    text-align: center;\n    width: 364px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.baloa-play-view__empty-matches .baloa-subtitle-2 {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 31px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    \n    .baloa-play-view__container {\n        margin-left: 0;\n    }\n\n    .baloa-play-view__skeleton-container {\n        grid-template-columns: 1fr;\n        grid-gap: 8px;\n        margin: 12px 9px;\n    }\n\n    .baloa-play-view__skeleton-container__element {\n        display: flex;\n        align-items: flex-start;\n        padding: 8px;\n        gap: 8px;\n    }\n\n    .baloa-play-view__skeleton-container__element__text-lines {\n        width: calc(100% - 128px);\n        padding: 0;\n    }\n\n    .baloa-play-view__skeleton-container-clips {\n        grid-template-columns: 1fr;\n        grid-gap: 10px;\n        margin: 10px;\n    }\n\n    .baloa-play-view__skeleton-container__element__text-lines-clips {\n        flex-wrap: nowrap;\n        align-items: center;\n    }\n\n    .baloa-play-view__section-header {\n        padding: 8px 12px 12px 12px;\n    }\n\n    .baloa-play-view__section-header .baloa-headline-2  {\n        font-size: 18px;\n    }\n\n    .baloa-play-view__section-header .hubicon-clear_option {\n        font-size: 24px;\n        color: var(--primary-very-dark-color);\n        margin-left: auto;\n    }\n\n    .baloa-play-view__matc-acces-denied {\n        margin-top: 80px;\n        width: 294px;\n    }\n    .baloa-play-view__empty-matches {\n        margin-top: 130px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
